/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorNotFound } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { PacktechCalculationRequest } from '../models';
// @ts-ignore
import type { PacktechCalculationResponse } from '../models';
/**
 * CalculationServicePacktechApi - axios parameter creator
 */
export const CalculationServicePacktechApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate product carbon footprint for PackTech
         * @param {PacktechCalculationRequest} packtechCalculationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packtechCalculation: async (packtechCalculationRequest: PacktechCalculationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'packtechCalculationRequest' is not null or undefined
            assertParamExists('packtechCalculation', 'packtechCalculationRequest', packtechCalculationRequest)
            const localVarPath = `/calculation/v1/calculate/pcf-packtech`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(packtechCalculationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationServicePacktechApi - functional programming interface
 */
export const CalculationServicePacktechApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationServicePacktechApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Calculate product carbon footprint for PackTech
         * @param {PacktechCalculationRequest} packtechCalculationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async packtechCalculation(packtechCalculationRequest: PacktechCalculationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PacktechCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.packtechCalculation(packtechCalculationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServicePacktechApi.packtechCalculation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationServicePacktechApi - factory interface
 */
export const CalculationServicePacktechApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationServicePacktechApiFp(configuration)
    return {
        /**
         * 
         * @summary Calculate product carbon footprint for PackTech
         * @param {CalculationServicePacktechApiPacktechCalculationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packtechCalculation(requestParameters: CalculationServicePacktechApiPacktechCalculationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PacktechCalculationResponse> {
            return localVarFp.packtechCalculation(requestParameters.packtechCalculationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for packtechCalculation operation in CalculationServicePacktechApi.
 */
export interface CalculationServicePacktechApiPacktechCalculationRequest {
    readonly packtechCalculationRequest: PacktechCalculationRequest
}

/**
 * CalculationServicePacktechApi - object-oriented interface
 */
export class CalculationServicePacktechApi extends BaseAPI {
    /**
     * 
     * @summary Calculate product carbon footprint for PackTech
     * @param {CalculationServicePacktechApiPacktechCalculationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public packtechCalculation(requestParameters: CalculationServicePacktechApiPacktechCalculationRequest, options?: RawAxiosRequestConfig) {
        return CalculationServicePacktechApiFp(this.configuration).packtechCalculation(requestParameters.packtechCalculationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

